import React, {useEffect, useState} from 'react';
import {Checkbox, Divider, FormControlLabel, FormGroup, Grid, RadioGroup, TextField, Typography} from "@mui/material";
import * as Yup from 'yup';
import {useParams} from 'react-router-dom';
import useAuth from "../../../hooks/useAuth";
import GeneralEditor, {MODE_CREATE, MODE_EDIT} from "../../../components/CrudFrom/GeneralEditor";
import {executeMutationUtil, executeQueryUtil} from "../../../utils/gqlUtil";
import localStrings from "../../../localStrings";
import {useNavigate} from "react-router";
import {dashboardBaseRoute} from "../../../routes/dashboard";
import {not_found_path} from "../../../routes";
import {
    addDataDataGridImplementationToCache,
    createDataGridImplementationMutation,
    getDataGridImplementationQuery,
    updateDataGridImplementationMutation
} from "../../../gql/dataGridImplementationGql";
import {getChartCategoriesQuery} from "../../../gql/chartCategoryGql";
import {Autocomplete} from "@mui/lab";

export const getDataGridImplementation = async (dataGridImplementationId,
                                             modeEdit, navigate) => {
    if (modeEdit == MODE_CREATE) {
        return null;
    }
    if (!modeEdit || modeEdit == MODE_EDIT) {
        var res =
            await executeQueryUtil(getDataGridImplementationQuery(dataGridImplementationId ));

        if (!res.data?.getDataGridImplementation) {
            navigate('/' + not_found_path);
            return;
        }
        return res;
    }
    return null;
}

export const saveForm = async (item, values, modeEdit, navigate, filter) => {
    let data;
    if (!modeEdit || modeEdit == MODE_EDIT) {
        data = {
            ...item,
            ...values,
            // code: values.code || '',
            height: parseInt(values.height) || 350,
        };
        await executeMutationUtil(updateDataGridImplementationMutation(data));

    }

    else if (modeEdit == MODE_CREATE){
        data = {...values};
        const created = await executeMutationUtil(createDataGridImplementationMutation(data));
        await addDataDataGridImplementationToCache([created.data?.addDataGridImplementation]);
        if (navigate) {
            navigate("/" + dashboardBaseRoute + "/DataGridImplementations/detail/" + created.data?.addDataGridImplementation?.id);
        }
    }


    return data;
}

const DataGridImplementationCreateUpdateForm = ({className, modeEdit}) => {

    const [chartCategories, setChartCategories] = useState(null);
    const [selectedChartCategory, setSelectedChartCategory] = useState(null);

    useEffect(() => {
        const loadData = async () => {
            let res = await executeQueryUtil(getChartCategoriesQuery());
            setChartCategories(res.data.getChartCategories);
        }
        loadData()
    }, []);

    let {dataGridImplementationId} = useParams();

    const {
        currentBrand,
        currentEstablishment,
        filter
    } = useAuth();
    const navigate = useNavigate();

    const buildFormValues = (item) => {
        return {
            initialValues: {
                name: item.name || '',
                mediaUrl: item.mediaUrl || '',
                chartCategoryId: item.chartCategoryId || null,
                title: item.title || null,
                height: item.height || 350,
                pivotModelContent: item.pivotModelContent || null,

            },
            validationSchema: {
                name: Yup.string().max(255).required(localStrings.check.fieldRequired),
                mediaUrl: Yup.string().url(localStrings.check.urlFormat).nullable(true),
                height: Yup.number().nullable(localStrings.check.numberFormat),
            }
        };
    }


    function getSelecctedChartCategory(values) {
        return chartCategories.find(chartCategory => chartCategory.id === values.chartCategoryId);
    }

    function getChartCategoryIds() {
        return chartCategories.map(chartCategory => chartCategory.id);
    }

    const getCardContentForm = ({
                                    errors,
                                    handleBlur,
                                    handleChange,
                                    handleSubmit,
                                    isSubmitting,
                                    setFieldValue,
                                    touched,
                                    values
                                }) => {
        return (
            <Grid
                container
                spacing={4}
            >

                {/*<p>{JSON.stringify(values)}</p>*/}
                <Grid
                    item
                    md={12}
                    xs={12}
                >
                    <TextField
                        inputProps={{
                            autocomplete:"new-password"
                        }}
                        fullWidth
                        helperText={touched.name && errors.name}
                        label={localStrings.name}
                        name="name"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        variant="standard"
                        required
                        value={values.name}
                    />
                </Grid>

                <Grid
                    item
                    md={12}
                    xs={12}
                >
                    <TextField
                        inputProps={{
                            autocomplete:"new-password"
                        }}
                        fullWidth
                        helperText={touched.mediaUrl && errors.mediaUrl}
                        label={localStrings.mediaUrl}
                        name="mediaUrl"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        variant="standard"
                        value={values.mediaUrl}
                    />
                </Grid>

                <Grid
                    item
                    md={12}
                    xs={12}
                >
                    <TextField
                        inputProps={{
                            autocomplete:"new-password"
                        }}
                        fullWidth
                        helperText={touched.title && errors.title}
                        label={localStrings.title}
                        name="title"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        variant="standard"
                        value={values.title}
                    />
                </Grid>

                <Grid
                    item
                    md={12}
                    xs={12}
                >
                    <TextField
                        inputProps={{
                            autocomplete:"new-password"
                        }}
                        fullWidth
                        helperText={touched.height && errors.height}
                        label={localStrings.heightInPixel}
                        name="height"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        variant="standard"
                        value={values.height}
                    />
                </Grid>

                <Grid
                    item
                    md={12}
                    xs={12}
                >
                    {/*<p>{values.chartCategoryId}</p>*/}
                    {/*<p>{JSON.stringify(chartCategories)}</p>*/}
                    {/*<p>{JSON.stringify(chartCategories.find(chartCategory => chartCategory.id === values.chartCategoryId))}</p>*/}
                    <Autocomplete
                        fullWidth
                        disablePortal
                        getOptionLabel={
                            (chartCategoryId) => {
                                return chartCategories.find(chartCategory => chartCategory.id === chartCategoryId)?.name;
                            }
                        }
                        options={getChartCategoryIds()}
                        value={values.chartCategoryId}
                        // value={chartCategories[1]}
                        onChange={
                            async  (event, value) => {
                                setFieldValue('chartCategoryId', value);
                            }}
                        renderInput={(params) => <TextField {...params} label={localStrings.chartCategory} />}
                    />
                </Grid>

            </Grid>
        );
    }




    return (

        <>


            {/*<p>{JSON.stringify(getDataGridImplementation(DataGridImplementationId, modeEdit, navigate) || [])}</p>*/}
            {currentEstablishment() && currentBrand() && chartCategories &&
                <GeneralEditor getItemFunction={() =>
                    getDataGridImplementation(dataGridImplementationId, modeEdit, navigate)}
                               className={className}
                               buildFormValues={buildFormValues}
                               getCardContentForm={getCardContentForm}
                               saveForm={(item, values) => saveForm(item, values, modeEdit, navigate, filter)}
                               applyButton={modeEdit == MODE_CREATE ? localStrings.create : localStrings.update}
                               resetFormProp={modeEdit == MODE_CREATE}
                               messageSuccess={modeEdit == MODE_CREATE ?
                                   localStrings.notif.dataGridImplementationCreated : localStrings.notif.dataGridImplementationUpdated}
                               titleForm={modeEdit == MODE_CREATE ? localStrings.createDataGridImplementation : localStrings.updateDataGridImplementation}
                               getPathToData={(result) => {
                                   return result.data.getDataGridImplementation;
                               }}
                />
            }
        </>
    )
};

export default DataGridImplementationCreateUpdateForm;
